import { useProducts } from "../../lib/products";
import { useProductModelJobFor } from "../../lib/productModelJobs";
import { parseCapture, turnCapture } from "../../lib/productCapture";
import { track } from "../../lib/telemetry";
import type { Furniture } from "../../lib/types";
import { ProductModelStatus } from "../ProductModelStatus";

/**
 * The 3D model line for a piece placed from a URL import: where its mesh
 * came from and "Turn model", or that one is still being built. Renders
 * nothing for pieces without either.
 */
export function PieceModelStatus({
  selected,
  onUpdate,
}: {
  selected: Furniture;
  onUpdate: (patch: Partial<Furniture>) => void;
}) {
  const job = useProductModelJobFor(selected.productId);
  // Shared rooms carry pieces unvalidated.
  const capture = parseCapture(selected.capture) ?? undefined;
  if (!capture && job?.status !== "building") return null;

  function turn() {
    if (!capture) return;
    const next = turnCapture(capture);
    onUpdate({ capture: next });
    // The saved product follows, so the next placement faces the same way.
    const products = useProducts.getState();
    const product = products.products.find((p) => p.id === selected.productId);
    if (product?.capture && product.capture.url === capture.url) {
      products.setProductCapture(product.id, { ...product.capture, yaw: next.yaw });
    }
    track("product_model_oriented", { source: capture.source });
  }

  return (
    <div className="px-4 pb-3" data-testid="piece-model-status">
      <ProductModelStatus
        state={capture ? capture.source : "building"}
        yaw={capture?.yaw}
        onTurn={capture ? turn : undefined}
      />
    </div>
  );
}
